import { useFetch } from "./FetchHook";

/** A DICOM/image file belonging to an imaging study (see ImagingStudyFileSerializer). */
export interface ImagingFileData {
  imaging_file_id: string;
  file_name: string | null;
  content_type: string | null;
  file_size_bytes: number | null;
  sop_instance_uid: string | null;
  file_sequence_number: number | null;
  custom_fields: Record<string, unknown> | null;
  /** Proxy URL that streams the file's bytes through the API (auth-gated). */
  file_url: string | null;
}

/** Fetch the files for an imaging study (the DICOM viewer's source list). */
export function useImagingStudyFiles(imagingStudyId: string | null) {
  return useFetch({
    endpointSuffix: `imaging-studies/${imagingStudyId}/files/`,
    enabled: !!imagingStudyId,
  });
}
